import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href"]

import { IonApp, IonRouterOutlet, IonBackdrop, IonToolbar, IonFab, IonTitle,IonFabButton, IonIcon, IonModal,IonHeader,IonButton,IonButtons,IonContent } from '@ionic/vue';
import { ref,watch,computed } from 'vue';
import {isMobile, theme,isConsole, steps,addStep, checkStep, initPage, openTicket, err_count, setSearch} from '@/plugins/interfaceControler';
import {showScan} from '@/plugins/scanControler';
import { hasRole, authenticated } from './plugins/authService';
import { resetSelectedUser } from './plugins/adminService';
import {appsOutline, help, colorPaletteOutline, chevronUpCircleOutline, chatbubblesOutline } from "ionicons/icons";
import mainForm from '@/components/forms/mainForm.vue';
import { VOnboardingWrapper, VOnboardingStep, useVOnboarding } from 'v-onboarding'
import 'v-onboarding/dist/style.css'
import { useRouter, useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter(),
  route = useRoute();
  const currentPath = computed(() => router.currentRoute.value.path);
  const searchParam = computed(()=> route.query?.search)
  const tour:any = computed(()=>router.currentRoute.value.meta ? router.currentRoute.value.meta.tour || [] : null)
  const leftSection = (value:string, old:string, section:string) => old?.startsWith(section) && !value.startsWith(section)
  watch(currentPath,(value, old)=>{
    initPage()
    if (value == '/shop/start') resetSelectedUser()
    if (value == '/shop/start' || leftSection(value, old, '/admin') || leftSection(value, old, '/main')) {
      setSearch('')
      ;(document.activeElement as HTMLElement)?.blur()
    }
    setTimeout(()=>startTour(),1000)
   
  })
  
  watch (searchParam,(value) => {
     setSearch(value)
  })
  if (searchParam.value) setSearch(searchParam.value)
 

  setTimeout(()=>startTour(),1000)

  function startTour(){
    
    if (!tour.value) return false
    tour.value.map((t:any)=>addStep(t))
    start()
  }
const wrapper = ref(null)
const { start } = useVOnboarding(wrapper)


function finish(){
  steps.value.map((s:any)=>checkStep(s.attachTo.element))
}

const model = ref({ record: {}, type:'helpdesk'})


function closeForm(){
  openTicket.value = false
  
}
//if (selectedCabinet.value && !selectedCabinet.value) selectedCabinet.value = null

setTimeout(()=>{
  err_count.value++
  if (err_count.value>5) return false
  //if (!document.getElementById('page-header')) document.location='/logout?error=true'

},2000)
//

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(IonApp), {
    class: _normalizeClass({'mobile': _unref(isMobile), 'console': _unref(isConsole)})
  }, {
    default: _withCtx(() => [
      _createElementVNode("link", {
        rel: "stylesheet",
        href: `${_unref(theme)}/style.css`
      }, null, 8, _hoisted_1),
      _createVNode(_component_router_view),
      (!_unref(isConsole) && !_unref(isMobile) && !_unref(showScan) && _unref(authenticated))
        ? (_openBlock(), _createBlock(_unref(IonFab), {
            key: 0,
            slot: "fixed",
            class: "no-print",
            id: "help-center",
            vertical: "bottom",
            horizontal: "end"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonFabButton), {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (openTicket.value=!_unref(openTicket)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(help) }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(openTicket))
        ? (_openBlock(), _createBlock(mainForm, {
            key: 1,
            title: "Supportdesk: Nieuwe vraag",
            "label-save": "Versturen >",
            show: _unref(openTicket),
            onClose: closeForm,
            delete: "",
            modelValue: model.value.record,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.record) = $event)),
            model: model.value.type,
            modal: true
          }, null, 8, ["show", "modelValue", "model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})